import React from 'react'
import { storiesOf } from '@storybook/react'

// Digital-Commons Theming
import { ThemeProvider } from 'styled-components'
import { getBaseTheme } from '../..'

// Component to surface in storybook
import Kebabmenu from '.'

// Story Setup
const stories = storiesOf('Digital-Commons/Kebabmenu', module)

// Theming setup
const mode = 'refinitiv'
const baseTheme = getBaseTheme({ mode })
const builtTheme = {
  mode,
  ...baseTheme
}

// Stories
stories
  .add('Default', () => (
    <ThemeProvider theme={builtTheme}>
      <Kebabmenu />
    </ThemeProvider>
  ))
